import { BRAND_COLORS, COLORS_BASIC, FUNCTIONAL_COLORS } from '../../dsm/color';
import { backgroundColor, borderColor, brandColor, palette, textColor } from '../../dsm/color-token';
export const appStudioProductColorToken = {
  'product-color': '#9300FF',
  'product-color-light-100': '#AB39FF',
  'product-color-light-200': '#C372FF',
  'product-color-light-300': '#DBABFF',
  'product-color-light-400': '#F4E5FF',
  'product-color-dark-100': '#7200C5',
  'product-color-dark-200': '#51008C',
  'product-color-dark-300': '#300053',
  'product-color-dark-400': '#0F001A'
};
const componentsColor = {
  'color-charts-primary': appStudioProductColorToken['product-color-dark-100'],
  'color-charts-secondary': appStudioProductColorToken['product-color-light-300']
};
export const appStudioColor = {
  COLORS_BASIC,
  COLORS: { ...BRAND_COLORS,
    ...FUNCTIONAL_COLORS
  },
  colors: { ...appStudioProductColorToken,
    ...palette,
    ...backgroundColor,
    ...textColor,
    ...borderColor,
    ...componentsColor,
    ...brandColor
  }
};